/* istanbul ignore file */
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { DataLockerLayout } from '@/components/layout/dataLocker/DataLockerLayout';
import { ProtectedVideoRoute } from '@/components/routes/ProtectedVideoRoute';
import { PitchSelectVideoPreview } from '@/components/video/PitchSelectVideoPreview';
import { PlayerVideoPreview } from '@/components/video/PlayerVideoPreview';
import { PlayerDataLockerPage } from '@/pages/dataLocker/aggregates/player/PlayerDataLockerPage';
import { PlayerDataLockerPlayerPreview } from '@/pages/dataLocker/aggregates/player/PlayerDataLockerPlayerPreview';
import { PlayerDataLockerPreview } from '@/pages/dataLocker/aggregates/player/PlayerDataLockerPreview';
import { TeamDataLockerPage } from '@/pages/dataLocker/aggregates/team/TeamDataLockerPage';
import { TeamDataLockerPreview } from '@/pages/dataLocker/aggregates/team/TeamDataLockerPreview';
import { TeamDataLockerVideoPreview } from '@/pages/dataLocker/aggregates/team/TeamDataLockerVideoPreview';
import { DataLockerLandingPage } from '@/pages/dataLocker/DataLockerLandingPage';
import { EventDataLockerPage } from '@/pages/dataLocker/eventData/EventDataLockerPage';
import { EventDataLockerPlayerPreview } from '@/pages/dataLocker/eventData/EventDataLockerPlayerPreview';
import { NotFound } from '@/pages/NotFound';

export const DataLockerRoutes = () => (
  <Routes>
    <Route element={<DataLockerLayout />}>
      <Route path="/" element={<DataLockerLandingPage />} />
      <Route path="events" element={<EventDataLockerPage />}>
        <Route path="player/preview" element={<EventDataLockerPlayerPreview />} />
        <Route path="video/preview" element={<ProtectedVideoRoute component={<PitchSelectVideoPreview />} />} />
      </Route>
      <Route path="players" element={<PlayerDataLockerPage />}>
        <Route path="preview" element={<PlayerDataLockerPreview />} />
        <Route path="player/preview" element={<PlayerDataLockerPlayerPreview />} />
        <Route path="video/preview" element={<PlayerVideoPreview />} />
      </Route>
      <Route path="teams" element={<TeamDataLockerPage />}>
        <Route path="preview" element={<TeamDataLockerPreview />} />
        <Route path="video/preview" element={<TeamDataLockerVideoPreview />} />
      </Route>
    </Route>
    <Route path="*" element={<NotFound />} />
  </Routes>
);
